import React, { useState, useEffect } from 'react';
import { Edit, Plus, AlertTriangle, Check, X, MessageSquare, DollarSign, FileText, Settings } from 'lucide-react';
import Sidebar from '../../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../../component/b2c/navBar/navBar';
import { useMyContext } from '../../../../../context/MyContext';
// import axios from 'axios';
import { IndianRupee } from "lucide-react";
import toast from 'react-hot-toast';
// import { nan } from 'zod';

const WhatsAppRatesManager = () => {
    const token = localStorage.getItem("token");
    const cus_id = localStorage.getItem("cus_id");
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [rates, setRates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        message_type: '',
        rate: '',
        description: '',
        status: 'Active'
    });
    const [editingId, setEditingId] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState({});

    // Mock data for demonstration
    useEffect(() => {
        fetchRates();
    }, []); // include token in deps if it comes from context or state

    const fetchRates = async () => {
        try {
            setLoading(true);

            const response = await fetch("https://api.pickupxpress.com/admin/whatsapp/rates", {
                method: "GET",
                headers: {
                    cus_id: cus_id,
                    "Content-Type": "application/json",
                    token: token,
                },
            });

            const data = await response.json();

            if (data.status === true) { // ✅ check boolean
                setRates(data?.data);
            } else {
                toast.error(data.message || "Something went wrong");
            }
        } catch (err) {
            toast.error("Failed to fetch rates");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    // Submit form (create or update)
    // Submit form (create or update)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                "https://api.pickupxpress.com/admin/whatsapp/setRate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        cus_id: cus_id,
                        token: token,
                    },
                    body: JSON.stringify({
                        // pass id for update, leave empty for new
                        message_type: formData.message_type,
                        rate: formData.rate,
                        description: formData.description,
                        status: 'Active'
                    }),
                }
            );

            const data = await response.json();

            if (data.status === true) {
                if (editingId) {
                    // Update existing rate in state
                    setRates((prev) =>
                        prev.map((rate) =>
                            rate.id === editingId ? { ...formData, id: editingId } : rate
                        )
                    );
                    showCustomAlert("Rate updated successfully!", "success");
                } else {
                    // Add new rate to state
                    const newRate = { ...formData, id: data?.insertedId || Date.now() };
                    setRates((prev) => [...prev, newRate]);
                    showCustomAlert("Rate created successfully!", "success");
                }
                resetForm();
            } else {
                showCustomAlert(data.message || "Failed to save rate", "error");
            }
        } catch (err) {
            console.error(err);
            showCustomAlert("Something went wrong while saving the rate", "error");
        } finally {
            setLoading(false);
        }
    };

    // Toggle status with confirmation
    // const handleStatusToggle = (rate, newStatus) => {
    //     setAlertConfig({
    //         title: `${newStatus === 'Active' ? 'Activate' : 'Deactivate'} Rate`,
    //         message: `Are you sure you want to ${newStatus === 'Active' ? 'activate' : 'deactivate'} this rate for "${rate.message_type}"?`,
    //         confirmText: newStatus === 'Active' ? 'Activate' : 'Deactivate',
    //         onConfirm: () => updateStatus(rate, newStatus),
    //         type: 'confirm'
    //     });
    //     setShowAlert(true);
    // };

   // Called from handleStatusToggle confirm
    // 1️⃣ When user clicks toggle button
    const handleStatusToggle = (rate, newStatus) => {
        setAlertConfig({
            title: `${newStatus === "Active" ? "Activate" : "Deactivate"} Rate`,
            message: `Are you sure you want to ${newStatus === "Active" ? "activate" : "deactivate"} this rate for "${rate.message_type}"?`,
            confirmText: newStatus === "Active" ? "Activate" : "Deactivate",
            type: "confirm",
            onConfirm: () => updateStatus(rate, newStatus), // <- call API only on confirm
        });
        setShowAlert(true); // show your custom alert modal
    };

    // 2️⃣ Called only when user confirms
    const updateStatus = async (rate, newStatus) => {
        setLoading(true);

        try {
            const response = await fetch(
                "https://api.pickupxpress.com/admin/whatsapp/setRate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        cus_id: cus_id,
                        token: token,
                    },
                    body: JSON.stringify({
                        id: rate.id,
                        message_type: rate.message_type,
                        rate: rate.rate,
                        description: rate.description,
                        status: newStatus,
                    }),
                }
            );

            const data = await response.json();

            if (data.status === true) {
                setRates((prev) =>
                    prev.map((r) =>
                        r.id === rate.id ? { ...r, status: newStatus } : r
                    )
                );

                showCustomAlert(
                    `Rate ${newStatus === "Active" ? "activated" : "deactivated"} successfully!`,
                    "success"
                );
            } else {
                showCustomAlert(data.message || "Failed to update status", "error");
            }
        } catch (err) {
            console.error(err);
            showCustomAlert("Something went wrong while updating status", "error");
        } finally {
            setLoading(false);
        }
    };

    // Edit rate
    const handleEdit = (rate) => {
        setFormData({
            message_type: rate.message_type,
            rate: rate.rate,
            description: rate.description,
            // status: rate.status
        });
        setEditingId(rate.id);
        setShowForm(true);
    };

    // Reset form
    const resetForm = () => {
        setFormData({
            message_type: '',
            rate: '',
            description: '',
            status: 'Active'
        });
        setEditingId(null);
        setShowForm(false);
    };

    // Custom alert function
    const showCustomAlert = (message, type) => {
        setAlertConfig({
            title: type === 'success' ? 'Success' : 'Error',
            message,
            type,
            onConfirm: () => setShowAlert(false)
        });
        setShowAlert(true);
    };

    // Custom Alert Component
    const CustomAlert = ({ config, onClose }) => {
        if (!config) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                <div className="bg-white rounded-2xl max-w-md w-full mx-4 shadow-2xl transform transition-all scale-100">
                    <div className="p-6">
                        <div className="flex items-center mb-4">
                            {config.type === 'success' && (
                                <div className="bg-gradient-to-r from-green-100 to-green-200 p-3 rounded-full mr-4">
                                    <Check className="w-6 h-6 text-green-600" />
                                </div>
                            )}
                            {config.type === 'error' && (
                                <div className="bg-gradient-to-r from-red-100 to-red-200 p-3 rounded-full mr-4">
                                    <X className="w-6 h-6 text-red-600" />
                                </div>
                            )}
                            {config.type === 'confirm' && (
                                <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 p-3 rounded-full mr-4">
                                    <AlertTriangle className="w-6 h-6 text-yellow-600" />
                                </div>
                            )}
                            <h3 className="text-xl font-bold text-gray-900">{config.title}</h3>
                        </div>
                        <p className="text-gray-600 mb-6 leading-relaxed">{config.message}</p>
                        <div className="flex justify-end space-x-3">
                            {config.type === 'confirm' && (
                                <button
                                    onClick={onClose}
                                    className="px-6 py-2 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all duration-200 font-medium"
                                >
                                    Cancel
                                </button>
                            )}
                            <button
                                onClick={() => {
                                    if (config.onConfirm) config.onConfirm();
                                    onClose();
                                }}
                                className={`px-6 py-2 rounded-xl transition-all duration-200 font-medium shadow-lg ${config.type === 'success'
                                    ? 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white'
                                    : config.type === 'error'
                                        ? 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white'
                                        : 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white'
                                    }`}
                            >
                                {config.confirmText || 'OK'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Enhanced Switch Component
    const StatusSwitch = ({ checked, onChange, disabled = false }) => (
        <label className="relative inline-flex items-center cursor-pointer group">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="sr-only peer"
            />
            <div className={`
                relative w-14 h-8 rounded-full transition-all duration-300 ease-in-out
                ${checked
                    ? 'bg-gradient-to-r from-green-400 to-green-500 shadow-lg shadow-green-200'
                    : 'bg-gradient-to-r from-gray-200 to-gray-300 shadow-inner'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'group-hover:shadow-lg'}
                peer-focus:ring-4 peer-focus:ring-blue-300/20
            `}>
                <div className={`
                    absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-lg
                    transform transition-all duration-300 ease-in-out
                    ${checked ? 'translate-x-6' : 'translate-x-0'}
                    flex items-center justify-center
                `}>
                    {checked ? (
                        <Check className="w-3 h-3 text-green-500" />
                    ) : (
                        <X className="w-3 h-3 text-gray-400" />
                    )}
                </div>
            </div>
            <span className={`ml-3 text-sm font-medium transition-colors ${checked ? 'text-green-700' : 'text-gray-500'
                }`}>
                {checked ? 'Active' : 'Inactive'}
            </span>
        </label>
    );

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>

            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                <div className={`min-h-screen w-full overflow-auto ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} `}>
                    <div className={`max-w-full overflow-auto mx-auto px-4 sm:px-6 lg:px-8 py-8 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white'} `}>
                        {/* Header */}
                        <div
                            className={`backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 p-3 mb-4 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                } ${isDarkMode ? 'text-white' : ''}`}
                        >
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                                <div className="flex items-start space-x-4">
                                    <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-4 rounded-2xl shadow-lg">
                                        <MessageSquare className="w-4 h-4 text-white" />
                                    </div>
                                    <div>
                                        <h1 className="dark:text-white text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent mb-2">
                                            WhatsApp Rates Management
                                        </h1>
                                        <p className="text-gray-600 text-lg">Manage your WhatsApp messaging rates and settings with ease</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowForm(!showForm)}
                                    className="mt-6 lg:mt-0 dark:text-white inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 font-medium"
                                >
                                    <Plus className="w-3 h-3 mr-2" />
                                    Add New Rate
                                </button>
                            </div>
                        </div>

                        {/* Form */}
                        {showForm && (
                            <div className={`bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 p-8 mb-8 transform transition-all duration-300 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white'}`}>
                                <div className="flex items-center mb-6">
                                    <div className="bg-gradient-to-r from-green-500 to-teal-600 p-3 rounded-xl mr-4">
                                        <Settings className="w-6 h-6 text-white" />
                                    </div>
                                    <h2 className="text-2xl dark:text-white font-bold text-gray-900">
                                        {editingId ? 'Edit Rate' : 'Add New Rate'}
                                    </h2>
                                </div>

                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="flex dark:text-white items-center text-sm font-semibold text-gray-700 mb-2">
                                            <MessageSquare className="w-4 h-4 mr-2 text-blue-500" />
                                            Message Type
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.message_type}
                                            onChange={(e) => setFormData({ ...formData, message_type: e.target.value })}
                                            className={`w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/50 ${isDarkMode ? "dark:bg-darkmodeColor dark:shadow-custom-dark " : ""}`}
                                            placeholder="e.g., shipment_ofd, delivery_confirmation"
                                            required
                                        />
                                    </div>

                                    <div className="space-y-2 dark:text-white">
                                        <label className="flex dark:text-white items-center text-sm font-semibold text-gray-700 mb-2">
                                            <IndianRupee className="w-4 h-4 mr-2 text-green-500" />
                                            Rate
                                        </label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            value={formData.rate}
                                            onChange={(e) => setFormData({ ...formData, rate: e.target.value })}
                                            className={`w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/50 ${isDarkMode ? "dark:bg-darkmodeColor dark:shadow-custom-dark " : ""}`}
                                            // className={`w-full   px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/50${isDarkMode ? "dark:bg-darkmodeColor dark:shadow-custom-dark " : ""}`}
                                            placeholder="e.g., 2.30"
                                            required
                                        />
                                    </div>

                                    <div className="lg:col-span-2 dark:text-white space-y-2 dark:text-white">
                                        <label className="flex dark:text-white items-center dark:text-white text-sm font-semibold text-gray-700 mb-2">
                                            <FileText className="w-4 h-4 mr-2 text-purple-500" />
                                            Description
                                        </label>
                                        <textarea
                                            value={formData.description}
                                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                            className={`w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/50 ${isDarkMode ? "dark:bg-darkmodeColor dark:shadow-custom-dark " : ""}`}
                                            // className={`w-full px-4  py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-300 bg-white/50 resize-none${isDarkMode ? "dark:bg-darkmodeColor dark:shadow-custom-dark " : ""}`}
                                            rows="3"
                                            placeholder="Enter a detailed description..."
                                            required
                                        />
                                    </div>

                                    {/* <div className="space-y-2">
                                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                                            Status
                                        </label>
                                        <StatusSwitch
                                            checked={formData.status === 'Active'}
                                            onChange={(e) => setFormData({
                                                ...formData,
                                                status: e.target.checked ? 'Active' : 'Inactive'
                                            })}
                                        />
                                    </div> */}

                                    <div className="lg:col-span-2 flex justify-end space-x-4 pt-6">
                                        <button
                                            type="button"
                                            onClick={resetForm}
                                            className="px-8 py-3 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all duration-300 font-medium"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleSubmit}
                                            disabled={loading || !formData.rate || !formData.description || !formData.message_type}
                                            className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 shadow-lg hover:shadow-xl font-medium"
                                        >
                                            {loading ? 'Saving...' : editingId ? 'Update Rate' : 'Create Rate'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Table */}
                        <div className={`bg-white/80  backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 -hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                }`}>
                            <div className="px-4 py-3 border-b border-gray-100">
                                <h2 className="text-xl font-bold dark:text-white text-gray-900">Current Rates</h2>
                                <p className="text-gray-600 mt-1">Manage and monitor your WhatsApp messaging rates</p>
                            </div>

                            {loading && rates.length === 0 ? (
                                <div className="p-12 text-center">
                                    <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent mx-auto"></div>
                                    <p className="mt-4 text-gray-600 text-lg">Loading rates...</p>
                                </div>
                            ) : (
                                <div className="relative">
                                    {/* Scrollable table container */}
                                    <div className="overflow-y-auto max-h-96 scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-gray-100 hover:scrollbar-thumb-blue-400">
                                        <table className="min-w-full">
                                            <thead className="bg-gradient-to-r from-gray-50 to-gray-100 sticky top-0 z-10 shadow-sm">
                                                <tr>
                                                    <th className={`dark:text-white px-8 py-4 text-left text-xs font-bold text-gray-600 uppercase tracking-wider ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                                        Message Type
                                                    </th>
                                                    <th className={`dark:text-white px-8 py-4 text-left text-xs font-bold text-gray-600 uppercase tracking-wider ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                                        Rate
                                                    </th>
                                                    <th className={`dark:text-white px-8 py-4 text-left text-xs font-bold text-gray-600 uppercase tracking-wider ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                                        Description
                                                    </th>
                                                    <th className={`dark:text-white px-8 py-4 text-left text-xs font-bold text-gray-600 uppercase tracking-wider ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                                        Status
                                                    </th>
                                                    <th className={`dark:text-white px-8 py-4 text-left text-xs font-bold text-gray-600 uppercase tracking-wider ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                                        Actions
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className={`divide-y divide-gray-100 bg-white  dark:text-white ${isDarkMode ? 'dark:bg-darkmodeColor ' : 'bg-white'}`}>
                                                {rates.map((rate, index) => (
                                                    <tr key={rate.id || index} className="transition-all duration-200 dark:text-white">
                                                        <td className="px-8 py-6 whitespace-nowrap dark:text-white">
                                                            <div className="flex items-center">
                                                                <div className="bg-gradient-to-r from-blue-100 to-purple-100 p-2 rounded-lg mr-3">
                                                                    <MessageSquare className="w-4 h-4 text-blue-600" />
                                                                </div>
                                                                <span className="text-sm font-semibold text-gray-900 dark:text-white">
                                                                    {rate.message_type}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="px-8 py-6 whitespace-nowrap">
                                                            <div className="flex items-center">
                                                                <span className="text-lg font-bold text-green-600">
                                                                    <p className="text-gray-800  dark:text-white font-medium">
                                                                        ₹{rate.rate}
                                                                    </p>
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className="px-8 py-6">
                                                            <div className="text-sm text-gray-900 dark:text-white max-w-xs">
                                                                {rate.description}
                                                            </div>
                                                        </td>
                                                        <td className="px-8 py-6 whitespace-nowrap">
                                                            <StatusSwitch
                                                                checked={rate.status === 'Active'}
                                                                onChange={(e) => {
                                                                    const newStatus = e.target.checked ? 'Active' : 'Inactive';
                                                                    handleStatusToggle(rate, newStatus);
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="px-8 py-6 whitespace-nowrap">
                                                            <button
                                                                onClick={() => handleEdit(rate)}
                                                                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl hover:from-blue-600 hover:to-purple-700 transition-all duration-300 shadow-md hover:shadow-lg font-medium"
                                                            >
                                                                <Edit className="w-4 h-4 mr-2" />
                                                                Edit
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {rates.length === 0 && !loading && (
                                                    <tr>
                                                        <td colSpan="5" className="px-8 py-12 text-center">
                                                            <div className="bg-gray-50 rounded-2xl p-8 inline-block">
                                                                <MessageSquare className="w-12 h-12 text-gray-300 mx-auto mb-4" />
                                                                <p className="text-gray-500 text-lg">No rates found</p>
                                                                <p className="text-gray-400">Add your first rate to get started</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Scroll indicator */}
                                    {rates.length > 4 && (
                                        <div className="absolute bottom-4 right-4 bg-blue-500 text-white p-2 rounded-full shadow-lg opacity-75 pointer-events-none">
                                            <div className="w-4 h-4 flex items-center justify-center">
                                                <div className="animate-bounce">↕</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Custom Alert */}
            {showAlert && (
                <CustomAlert
                    config={alertConfig}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};
export default WhatsAppRatesManager;